<template>
  <div class="input input--quantity" upsell-qty>
    <VButton
      v-if="!$attrs.readonly"
      class="input__quantity-btn input__quantity-btn--decrement"
      label="Decrement Quantity"
      :hide-label="true"
      @click.prevent="(quantity - step < 0) ? 0: quantity-= step"
    >
      <Icon :name="iconDecrement" size="10px" fill="transparent" stroke="currentColor" />
    </VButton>
    <label :class="labelClass" :for="`quantity-input__${_uid}`">{{
      label
    }}</label>
    <input
      :id="`quantity-input__${_uid}`"
      name="quantity"
      type="number"
      style="pointer-events: none;"
      :min="min"
      :max="max"
      v-model="quantity"
      :readonly="$attrs.readonly"
    />
    <VButton
      v-if="!$attrs.readonly"
      class="input__quantity-btn input__quantity-btn--increment"
      label="Increment Quantity"
      :hide-label="true"
      @click.prevent="quantity+= step"
      :disabled="disableIncrement"
    >
      <Icon :name="iconIncrement" size="10px" fill="currentColor" />
    </VButton>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import VButton from 'scripts/components/basic/VButton.vue';

  export default {
    name: 'QuantityInput',
    components: { Icon, VButton },
    props: {
      min: [Number, String],
      max: [Number, String],
      value: [Number, String],
      step: [Number, String],
      label: String,
      hideLabel: {
        type: Boolean,
        default: true,
      },
      iconDecrement: {
        type: String,
        default: 'minus',
      },
      iconIncrement: {
        type: String,
        default: 'plus',
      },
      fillClass: String,
      disableIncrement: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        quantity: (this.value * this.step) || 1,
      };
    },
    computed: {
      labelClass() {
        return {
          'u-sr-only': this.hideLabel,
        };
      },
    },
    watch: {
      value(value) {
        this.quantity = value;
      },
      quantity(value) {
        if (this.min && value < this.min) this.quantity = this.min;
        if (this.max && value > this.max) this.quantity = this.max;
        this.$emit('input', this.quantity);
      },
    },
  };
</script>
